var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "version_page" }, [
    _vm._m(0),
    _c("div", { staticClass: "content" }, [
      _c("p", { staticClass: "tip" }, [
        _vm._v("如有疑问，请联系客服：400-808-9187")
      ]),
      _vm._m(1),
      _c(
        "ul",
        { staticClass: "list_ul" },
        [
          _vm._m(2),
          _c("li", { staticClass: "list_li" }, [
            _c("div", { staticClass: "li_div" }, [_vm._v("-")]),
            _vm._m(3),
            _c(
              "div",
              { staticClass: "li_div li_flex" },
              [
                _c("el-switch", {
                  attrs: {
                    disabled: _vm.switchVal === 2,
                    "inactive-value": 1,
                    "active-value": 2,
                    "active-color": "#ec1c1c"
                  },
                  on: { change: _vm.switchChangeFn },
                  model: {
                    value: _vm.switchVal,
                    callback: function($$v) {
                      _vm.switchVal = $$v
                    },
                    expression: "switchVal"
                  }
                }),
                _c("span", { staticClass: "flex_text" }, [
                  _vm._v(_vm._s(_vm.switchVal === 2 ? "已开启" : "已关闭"))
                ])
              ],
              1
            )
          ]),
          _vm._l(_vm.listArr, function(item, index) {
            return _c("li", { key: index, staticClass: "list_li" }, [
              _c("div", { staticClass: "li_div" }, [
                _c("p", { staticClass: "bold_title" }, [
                  _vm._v(_vm._s(item.title))
                ]),
                _c("span", [_vm._v(_vm._s(item.tip))])
              ]),
              _c("div", { staticClass: "li_div li_center" }, [
                item.text2
                  ? _c("i", {
                      staticClass: "el-icon-check",
                      staticStyle: {
                        color: "#00cb14",
                        "font-size": "20px",
                        "font-weight": "bold"
                      }
                    })
                  : _c("i", {
                      staticClass: "el-icon-close",
                      staticStyle: {
                        color: "#ec1c1c",
                        "font-size": "20px",
                        "font-weight": "bold"
                      }
                    })
              ]),
              _c("div", { staticClass: "li_div" }, [
                item.text3
                  ? _c("i", {
                      staticClass: "el-icon-check",
                      staticStyle: {
                        color: "#00cb14",
                        "font-size": "20px",
                        "font-weight": "bold"
                      }
                    })
                  : _c("i", {
                      staticClass: "el-icon-close",
                      staticStyle: {
                        color: "#ec1c1c",
                        "font-size": "20px",
                        "font-weight": "bold"
                      }
                    })
              ])
            ])
          }),
          _c("li", { staticClass: "list_li" }, [
            _c("div", { staticClass: "li_div" }, [_vm._v("-")]),
            _vm._m(4),
            _c(
              "div",
              { staticClass: "li_div li_flex" },
              [
                _c("el-switch", {
                  attrs: {
                    disabled: _vm.switchVal === 2,
                    "inactive-value": 1,
                    "active-value": 2,
                    "active-color": "#ec1c1c"
                  },
                  on: { change: _vm.switchChangeFn },
                  model: {
                    value: _vm.switchVal,
                    callback: function($$v) {
                      _vm.switchVal = $$v
                    },
                    expression: "switchVal"
                  }
                }),
                _c("span", { staticClass: "flex_text" }, [
                  _vm._v(_vm._s(_vm.switchVal === 2 ? "已开启" : "已关闭"))
                ])
              ],
              1
            )
          ])
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "banner_img" }, [
      _c("img", {
        staticClass: "img",
        attrs: { src: require("../static/images/version_banner.jpg"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content_title" }, [
      _c("p", { staticClass: "big_size" }, [_vm._v("产品服务比对介绍")]),
      _vm._v("\n          全周期一站式签管一体化平台\n        ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "list_li" }, [
      _c("div", { staticClass: "li_div li_1" }, [
        _c("p", { staticClass: "bold_title" }, [_vm._v("产品服务")])
      ]),
      _c("div", { staticClass: "li_div li_center li_2" }, [
        _c("p", { staticClass: "bold_title" }, [_vm._v("基础版")]),
        _vm._v("\n              电子合同基本签管能力\n            ")
      ]),
      _c("div", { staticClass: "li_div li_3" }, [
        _c("p", { staticClass: "bold_title" }, [_vm._v("高级版")]),
        _vm._v("\n              满足企业签管一体化需求\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "li_div li_center" }, [
      _c("p", { staticClass: "li_button" }, [_vm._v("默认开通")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "li_div li_center" }, [
      _c("p", { staticClass: "li_button" }, [_vm._v("默认开通")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6039ac1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6039ac1e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/versionPage.vue
// module id = fErM
// module chunks = 207